<template>
    <transition appear name="fade-transition">
        <span class="display__date">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled">
                {{ displayValue }}
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayDate',
    extends: Display,
    computed: {
        displayValue() {
            if (this._.isNil(this.value) && this.fallback) {
                return this.fallback;
            }
            return this.toDate(this.value, this.getOption('format', 'DD/MM/YYYY'));
        }
    }
};
</script>
